// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1684":"c1951f3e","8705":"c1951f3e"}[chunkId] + ".chunk.css";
};